import { format } from "date-fns";
import pt from "date-fns/locale/pt";

export function formatLeadDate(dateString) {
  try {
    return format(new Date(dateString), "dd/MM/yyyy 'às' HH:mm", { locale: pt });
  } catch (error) {
    return "Data inválida";
  }
}
